export default __webpack_public_path__ + "static/media/Scorpio.861f4a43.svg";